import { render } from "./ModalOrdersAbort.vue?vue&type=template&id=4caba27d"
import script from "./ModalOrdersAbort.vue?vue&type=script&lang=js"
export * from "./ModalOrdersAbort.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__